export default __webpack_public_path__ + "static/media/page-cropped.54206d3b.jpg";